(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nsl-counter-announcement-bar-custom"] && !Shopify.designMode) return;
  try {
    
function initCountdown() {
  const section = document.querySelector('.cc-nexus-clock-announcement-wrapper-custom');
  if (!section) return;

  const targetTimeString = section.getAttribute("data-daily-time"); // e.g. "16:00"

  if (!targetTimeString) {
    console.error("Daily time missing");
    return;
  }

  function getNextTargetTime() {
    const now = new Date();
    const [hours, minutes] = targetTimeString.split(":").map(Number);

    // create today's target
    const target = new Date();
    target.setHours(hours, minutes, 0, 0);

    // If target time already passed -> set to tomorrow
    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }

    return target.getTime();
  }

  let targetTime = getNextTargetTime();

  function updateTimer() {
    const now = new Date().getTime();
    let diff = targetTime - now;

    if (diff <= 0) {
      // Reset for next day
      targetTime = getNextTargetTime();
      diff = targetTime - now;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff %= (1000 * 60 * 60);

    const minutes = Math.floor(diff / (1000 * 60));
    diff %= (1000 * 60);

    const seconds = Math.floor(diff / 1000);

    document.getElementById("js-clock-hours").textContent = String(hours).padStart(2, "0");
    document.getElementById("js-clock-minutes").textContent = String(minutes).padStart(2, "0");
    document.getElementById("js-clock-seconds").textContent = String(seconds).padStart(2, "0");

    // Hide days because not needed
    const daysContainer = document.getElementById('days-container');
    if (daysContainer) daysContainer.style.display = "none";
  }

  updateTimer();
  const timer = setInterval(updateTimer, 1000);

  // handle Shopify editor
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCountdown);
  }
}

document.addEventListener('DOMContentLoaded', initCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsl-counter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initCountdown() {
    const section = document.querySelector('.cc-nexus-clock-announcement-wrapper');
    if (!section) return;

    const targetISO = section.getAttribute('data-target');
    const targetTime = Date.parse(targetISO);

    if (isNaN(targetTime)) {
      console.error('Invalid countdown target:', targetISO);
      return;
    }
    function updateTimer() {
      const now = new Date().getTime();
      let diff = targetTime - now;

      if (diff <= 0) {
        clearInterval(timer);
        document.getElementById('js-clock-days').textContent = "00";
        document.getElementById('js-clock-hours').textContent = "00";
        document.getElementById('js-clock-minutes').textContent = "00";
        document.getElementById('js-clock-seconds').textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff = diff % (1000 * 60 * 60 * 24);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      diff = diff % (1000 * 60 * 60);
      const minutes = Math.floor(diff / (1000 * 60));
      diff = diff % (1000 * 60);
      const seconds = Math.floor(diff / 1000);

      const daysContainer = document.getElementById('days-container');
      if (days > 0) {
        daysContainer.style.display = 'flex';
      } else {
        daysContainer.style.display = 'none';
      }

      document.getElementById('js-clock-days').textContent = days.toString().padStart(2, '0');
      document.getElementById('js-clock-hours').textContent = hours.toString().padStart(2, '0');
      document.getElementById('js-clock-minutes').textContent = minutes.toString().padStart(2, '0');
      document.getElementById('js-clock-seconds').textContent = seconds.toString().padStart(2, '0');
    }
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
  }

  document.addEventListener('DOMContentLoaded', initCountdown);
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCountdown);
    document.addEventListener('shopify:section:unload', () => clearInterval(timer));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.new-product-recommendations');
  const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.new-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        $('.product-recommendations-section .ProductList-slider').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '.product-recommendations-section .slider-prev',
          nextArrow: '.product-recommendations-section .slider-next',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true
              }
            }
          ]
      }); 
      })
      .catch(e => {
        console.error(e);
      });



  } catch(e) { console.error(e); }
})();
})();
